var _path, _circle, _line, _line2, _line3, _line4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoystick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9,25l-3-14.9c-0.3-1.3-1.1-2.5-2.2-3.2c-1.9-1.1-4.3-0.8-5.8,0.7L18.6,9h-2h-1.1h-2l-1.4-1.4     c-1.5-1.5-3.9-1.8-5.8-0.7c-1.2,0.7-2,1.8-2.2,3.2L1.1,25c-0.3,1.6,0.9,3,2.5,3c0.6,0,1.1-0.2,1.5-0.7L8.8,23c1.7-1.9,4.1-3,6.6-3     h1.1c2.5,0,5,1.1,6.6,3l3.8,4.3c0.4,0.4,0.9,0.7,1.5,0.7C30.1,28,31.3,26.5,30.9,25z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 14,
    r: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 14,
    x2: 7,
    y2: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 15,
    y2: 13
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 16,
    x2: 15,
    y2: 16
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystick);
export default __webpack_public_path__ + "static/media/joystick.3bad8b7802d934dc0a16d343c8704ffc.svg";
export { ForwardRef as ReactComponent };